import { call, put, takeLatest } from "redux-saga/effects";
import { lePhiBuocNhayApi } from "../../../api/category/lePhiBuocNhayApi";
import { loaiThuTuyenSinhApi } from "../../../api/category/loaiThuTuyenSinhApi";
import { ITsLePhiBuocNhaySaveRequest } from "../../../model/request/category/tsLePhiBuocNhaySaveRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import {
  eTsLePhiBuocNhayActionIds,
  ITsLePhiBuocNhayActionTypes,
} from "../../action-types/category/ITsLePhiBuocNhayActions";
import { IHeNganhTheoDotTuyenSinh } from "../../reducer-model/category/IDmLoaiThuTuyenSinhReducer";

export function* lePhiBuocNhaySaga(): any {
  yield takeLatest(eTsLePhiBuocNhayActionIds.LOAD_START, loadWorker);
  yield takeLatest(
    eTsLePhiBuocNhayActionIds.LOAD_HE_NGANH_START,
    loadHeNganhWorker
  );
  yield takeLatest(eTsLePhiBuocNhayActionIds.SAVE_START, saveWorker);
}

function* loadWorker(action: ITsLePhiBuocNhayActionTypes): any {
  const res: IBaseRespone = yield call(
    lePhiBuocNhayApi.SelectByDot,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.category.lePhiBuocNhay.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.lePhiBuocNhay.LOAD_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* loadHeNganhWorker(action: ITsLePhiBuocNhayActionTypes): any {
  // Dùng chung endpoint hệ/ngành theo đợt của module mức thu tuyển sinh.
  const res: IBaseRespone = yield call(
    loaiThuTuyenSinhApi.SelectHeNganhsByDot,
    action.payload as number
  );
  if (res.is_success) {
    yield put(
      rootActions.category.lePhiBuocNhay.LOAD_HE_NGANH_SUCCESS(
        res.data as IHeNganhTheoDotTuyenSinh[]
      )
    );
  } else {
    yield put(rootActions.category.lePhiBuocNhay.LOAD_HE_NGANH_ERROR("Có lỗi"));
  }
}

function* saveWorker(action: ITsLePhiBuocNhayActionTypes): any {
  const req = action.payload as ITsLePhiBuocNhaySaveRequest;
  const res: IBaseRespone = yield call(lePhiBuocNhayApi.Save, req);
  if (res && res.is_success) {
    yield put(
      rootActions.category.lePhiBuocNhay.SAVE_SUCCESS({
        id_he: req.id_he,
        id_nganh: req.id_nganh,
        items: res.data,
      })
    );
  } else {
    yield put(
      rootActions.category.lePhiBuocNhay.SAVE_ERROR(res?.message ?? "Có lỗi")
    );
  }
}
